import React from "react";
import {
  compareTwoObjectsDiff,
  CustomGroupRule,
  CustomRuleAliasKey,
} from "helpers/Compare";
import ConfigDiffView from "components/common/ConfigDiffView";
import SaveChangedHintWidget from "components/common/SaveChangedHintWidget";

class CustomUPRDiffView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      diffs: [],
    };
  }

  render() {
    const {
      originalRules,
      newRules,
      handleRollBack,
      refData,
      isInModal = false,
    } = this.props;

    // Indicate the path and name with a unique key.
    const uniqIdMap = new Map()
      .set("", { id: "id" })
      .set("[].targetingSection.customs[]", { id: "keyId" });

    // Indicate an array of paths that need to match by location.
    const sortedArray = [
      "[].priceSection.priceSettings",
      "[].targetingSection.customs",
    ];

    const diffs = compareTwoObjectsDiff(
      originalRules,
      newRules,
      uniqIdMap,
      sortedArray
    );

    return (
      <>
        <ConfigDiffView
          diffs={diffs}
          groupRule={CustomGroupRule}
          refData={refData}
          aliasKey={CustomRuleAliasKey}
          handleRollBack={handleRollBack}
        ></ConfigDiffView>
        {diffs.length > 0 && !isInModal && (
          <SaveChangedHintWidget diffCount={diffs.length} bottom="3rem" />
        )}
      </>
    );
  }
}

export default CustomUPRDiffView;
